import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { X } from "lucide-react";
import { LG } from "../../../../styles/liquidGlass";

interface DrawerHeaderProps {
  onClose: () => void;
}

export const DrawerHeader: React.FC<DrawerHeaderProps> = ({ onClose }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      px: 2.5,
      py: 2,
      borderBottom: `1px solid ${LG.color.divider}`,
    }}
  >
    <Typography
      sx={{
        fontWeight: 600,
        fontSize: "1rem",
        letterSpacing: "0.15em",
        color: LG.color.text,
        textTransform: "uppercase",
      }}
    >
      MOUCHI
    </Typography>
    <IconButton
      onClick={onClose}
      size="small"
      sx={{
        color: LG.color.textSecondary,
        p: 0.75,
        borderRadius: LG.radius.sm,
        "&:hover": { background: LG.color.surface, color: LG.color.text },
      }}
    >
      <X size={18} strokeWidth={1.5} />
    </IconButton>
  </Box>
);
